import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-79c3e6b8")

_pushScopeId("data-v-79c3e6b8")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__body" }
const _hoisted_3 = { class: "page__container" }
const _hoisted_4 = { class: "players--table" }
const _hoisted_5 = { class: "table__header row" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span class=\"header__cell cell cell--name\" data-v-79c3e6b8>Nom</span><span class=\"header__cell cell cell--shortinfo\" data-v-79c3e6b8>Nom et Contact</span><span class=\"header__cell cell cell--gender\" data-v-79c3e6b8>Sexe</span><span class=\"header__cell cell cell--phone\" data-v-79c3e6b8>Téléphone</span><span class=\"header__cell cell cell--email\" data-v-79c3e6b8>Courriel</span><span class=\"header__cell cell cell--info\" data-v-79c3e6b8>Informations additionnelles</span>", 6)
const _hoisted_12 = {
  key: 0,
  class: "header__cell cell cell--friendsWith"
}
const _hoisted_13 = {
  key: 1,
  class: "row__cell cell cell--actions"
}
const _hoisted_14 = { class: "row__cell cell cell--name" }
const _hoisted_15 = { class: "row__cell cell cell--shortinfo" }
const _hoisted_16 = { class: "cell--infolist" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 3,
  class: "knownteams__row"
}
const _hoisted_21 = { class: "row__cell cell cell--gender" }
const _hoisted_22 = { class: "row__cell cell cell--phone" }
const _hoisted_23 = { class: "row__cell cell cell--email" }
const _hoisted_24 = { class: "row__cell cell cell--info" }
const _hoisted_25 = {
  key: 0,
  class: "row__cell cell cell--friendsWith"
}
const _hoisted_26 = {
  key: 1,
  class: "row__cell cell cell--actions"
}
const _hoisted_27 = {
  key: 0,
  class: "row row--admin"
}
const _hoisted_28 = { class: "row__cell cell filters--team" }
const _hoisted_29 = { class: "team__row" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "icon-plus-circled" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "section--title" }, [
  /*#__PURE__*/_createVNode("span", null, " M'ajouter à cette liste ")
], -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "section--description" }, " Donnez nous plus d'informations sur vous afin de vous ajouter à cette liste. Vous recevrez un courriel de confirmation lorsque ce sera fait. Au plaisir! ", -1)
const _hoisted_33 = {
  key: 0,
  class: "section--description emphasize--small"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" En plus de faire la demande sur être ajouté à cette liste, assurez-vous d'aussi faire une demande d'adhésion au ")
const _hoisted_35 = { class: "facebook__link" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Les capitaines y publient leurs demandes quand il manque des joueur.euses. ")
const _hoisted_37 = { class: "addme--table " }
const _hoisted_38 = { class: "addme--column" }
const _hoisted_39 = { class: "row__container" }
const _hoisted_40 = { class: "row__input" }
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { class: "header__input addme--title" }, "Nom: ", -1)
const _hoisted_42 = {
  key: 0,
  class: "error--msg"
}
const _hoisted_43 = {
  key: 1,
  class: "noerror__box"
}
const _hoisted_44 = { class: "row__container" }
const _hoisted_45 = { class: "row__input" }
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { class: "header__input addme--title" }, " Sexe: ", -1)
const _hoisted_47 = {
  key: 0,
  class: "error--msg gender--error"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("option", {
  disabled: "",
  selected: "",
  value: ""
}, null, -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "noerror__box" }, null, -1)
const _hoisted_50 = { class: "row__container" }
const _hoisted_51 = { class: "row__input" }
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "header__input addme--title" }, " Courriel: ", -1)
const _hoisted_53 = {
  key: 0,
  class: "error--msg"
}
const _hoisted_54 = {
  key: 1,
  class: "noerror__box"
}
const _hoisted_55 = { class: "row__container" }
const _hoisted_56 = { class: "row__input" }
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "header__input addme--title" }, " Téléphone: ", -1)
const _hoisted_58 = {
  key: 0,
  class: "error--msg"
}
const _hoisted_59 = {
  key: 1,
  class: "noerror__box"
}
const _hoisted_60 = { class: "addme--column" }
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "header__input" }, " Parlez-nous un peu de vous: ", -1)
const _hoisted_62 = {
  key: 0,
  class: "error--msg"
}
const _hoisted_63 = {
  key: 1,
  class: "noerror__box"
}
const _hoisted_64 = { class: "button__container" }
const _hoisted_65 = /*#__PURE__*/_createVNode("i", { class: "icon-plus-circled" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TeamLabel = _resolveComponent("TeamLabel")
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            (_ctx.canViewFriendsWith)
              ? (_openBlock(), _createBlock("span", _hoisted_12, "Ami(e)s"))
              : _createCommentVNode("", true),
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock("span", _hoisted_13))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.freeAgents, (agent, ix) => {
            return (_openBlock(), _createBlock("div", { key: ix }, [
              _createVNode("div", {
                class: ["row", {'fading_row':_ctx.lastFreeAgentAdded(agent.name)}]
              }, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("span", null, _toDisplayString(agent.name), 1)
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("b", null, _toDisplayString(agent.name), 1),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("span", null, " Sexe: " + _toDisplayString(agent.gender), 1),
                    (_ctx.hasTelephone(agent))
                      ? (_openBlock(), _createBlock("span", _hoisted_17, " Tel: " + _toDisplayString(agent.cell), 1))
                      : _createCommentVNode("", true),
                    (_ctx.hasEmail(agent))
                      ? (_openBlock(), _createBlock("span", _hoisted_18, " Courriel: " + _toDisplayString(agent.email), 1))
                      : _createCommentVNode("", true),
                    (_ctx.canViewFriendsWith && _ctx.hasFriends(agent))
                      ? (_openBlock(), _createBlock("div", _hoisted_19, " Ami(e)s des: "))
                      : _createCommentVNode("", true),
                    (_ctx.canViewFriendsWith && _ctx.hasFriends(agent))
                      ? (_openBlock(), _createBlock("div", _hoisted_20, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(agent.knownteams, (team) => {
                            return (_openBlock(), _createBlock("span", {
                              key: team,
                              class: "knownteams__item"
                            }, [
                              _createVNode(_component_TeamLabel, {
                                team: _ctx.teamInfo(team)
                              }, null, 8, ["team"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("span", null, _toDisplayString(agent.gender), 1)
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("span", null, _toDisplayString(agent.cell), 1)
                ]),
                _createVNode("div", _hoisted_23, [
                  _createVNode("span", null, _toDisplayString(agent.email), 1)
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("span", null, _toDisplayString(agent.info), 1)
                ]),
                (_ctx.canViewFriendsWith)
                  ? (_openBlock(), _createBlock("div", _hoisted_25, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(agent.knownteams, (team) => {
                        return (_openBlock(), _createBlock("div", {
                          key: team,
                          class: "team__row"
                        }, [
                          _createVNode(_component_TeamLabel, {
                            team: _ctx.teamInfo(team)
                          }, null, 8, ["team"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock("span", _hoisted_26, [
                      _createVNode(_component_ConfirmAction, {
                        type: "delete",
                        onConfirm: ($event: any) => (_ctx.removeFreeAgent(agent))
                      }, null, 8, ["onConfirm"])
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ]))
          }), 128)),
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newFreeAgentName = $event)),
                  class: "row__cell cell input",
                  placeholder: "Nom",
                  type: "text",
                  tabindex: "-5"
                }, null, 512), [
                  [_vModelText, _ctx.newFreeAgentName]
                ]),
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newFreeAgentGender = $event)),
                  class: "row__cell cell"
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.genderTypes, (type, ix) => {
                    return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(type), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.newFreeAgentGender]
                ]),
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newFreeAgentCell = $event)),
                  class: "row__cell cell input",
                  placeholder: "Téléphone",
                  type: "text",
                  tabindex: "-3"
                }, null, 512), [
                  [_vModelText, _ctx.newFreeAgentCell]
                ]),
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.newFreeAgentEmail = $event)),
                  class: "row__cell cell input",
                  placeholder: "Courriel",
                  type: "text",
                  tabindex: "-2"
                }, null, 512), [
                  [_vModelText, _ctx.newFreeAgentEmail]
                ]),
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.newFreeAgentInfo = $event)),
                  class: "row__cell cell input",
                  placeholder: "Infos",
                  type: "text",
                  tabindex: "-1"
                }, null, 512), [
                  [_vModelText, _ctx.newFreeAgentInfo]
                ]),
                _createVNode("div", _hoisted_28, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.friendsWith, (team, ix) => {
                    return (_openBlock(), _createBlock("div", {
                      key: ix,
                      class: "team__row"
                    }, [
                      _withDirectives(_createVNode("select", {
                        "onUpdate:modelValue": ($event: any) => (_ctx.friendsWith[ix] = $event)
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedTeams, (team, ix) => {
                          return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(team), 1))
                        }), 128))
                      ], 8, ["onUpdate:modelValue"]), [
                        [_vModelSelect, _ctx.friendsWith[ix]]
                      ])
                    ]))
                  }), 128)),
                  _createVNode("div", _hoisted_29, [
                    _withDirectives(_createVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.friendsWith[_ctx.friendsWith.length] = $event))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedTeams, (team, ix) => {
                        return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(team), 1))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.friendsWith[_ctx.friendsWith.length]]
                    ])
                  ])
                ]),
                _createVNode("div", {
                  class: ["button button--action input", {'button--disabled': !_ctx.freeAgentAddValid}],
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addFreeAgent && _ctx.addFreeAgent(...args)))
                }, [
                  _hoisted_30
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_31,
        _hoisted_32,
        (_ctx.hasAgentLibreLink)
          ? (_openBlock(), _createBlock("div", _hoisted_33, [
              _hoisted_34,
              _createVNode("span", _hoisted_35, [
                _createVNode("a", {
                  href: _ctx.agentLibreLink,
                  title: "Ouvrir le groupe facebook des agents libres"
                }, " groupe facebook des agents libres.", 8, ["href"])
              ]),
              _hoisted_36
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_37, [
          _createVNode("div", _hoisted_38, [
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, [
                _hoisted_41,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.addMeName = $event)),
                  class: ["addme--simple input", {'error--display':(_ctx.hasInputErrorName && !_ctx.validName)}],
                  type: "text",
                  tabindex: "1",
                  onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showErrorName && _ctx.showErrorName(...args)))
                }, null, 34), [
                  [_vModelText, _ctx.addMeName]
                ])
              ]),
              (_ctx.hasInputErrorName && !_ctx.validName)
                ? (_openBlock(), _createBlock("div", _hoisted_42, " Nom invalide. Ne peut contenir que des lettres et certains caractères spéciaux. "))
                : (_openBlock(), _createBlock("div", _hoisted_43))
            ]),
            _createVNode("div", _hoisted_44, [
              _createVNode("div", _hoisted_45, [
                _hoisted_46,
                (_ctx.hasInputErrorGender && !_ctx.validGender)
                  ? (_openBlock(), _createBlock("span", _hoisted_47, " * "))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.addMeGender = $event)),
                  class: "addme--simple input",
                  tabindex: "2",
                  onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showErrorGender && _ctx.showErrorGender(...args)))
                }, [
                  _hoisted_48,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.genderTypes, (type, ix) => {
                    return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(type), 1))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.addMeGender]
                ])
              ]),
              _hoisted_49
            ]),
            _createVNode("div", _hoisted_50, [
              _createVNode("div", _hoisted_51, [
                _hoisted_52,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.addMeEmail = $event)),
                  class: ["addme--simple input", {'error--display':(_ctx.hasInputErrorEmail && !_ctx.validEmail)}],
                  type: "text",
                  tabindex: "3",
                  onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.showErrorEmail && _ctx.showErrorEmail(...args)))
                }, null, 34), [
                  [_vModelText, _ctx.addMeEmail]
                ])
              ]),
              (_ctx.hasInputErrorEmail && !_ctx.validEmail)
                ? (_openBlock(), _createBlock("div", _hoisted_53, " Format non supporté. Entrez une adresse valide. "))
                : (_openBlock(), _createBlock("div", _hoisted_54))
            ]),
            _createVNode("div", _hoisted_55, [
              _createVNode("div", _hoisted_56, [
                _hoisted_57,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.addMePhoneNumber = $event)),
                  class: ["addme--simple input", {'error--display':(_ctx.hasInputErrorPhone && !_ctx.validPhoneNumber)}],
                  type: "text",
                  placeholder: "Facultatif",
                  tabindex: "4",
                  onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.showErrorPhone && _ctx.showErrorPhone(...args)))
                }, null, 34), [
                  [_vModelText, _ctx.addMePhoneNumber]
                ])
              ]),
              (_ctx.hasInputErrorPhone && !_ctx.validPhoneNumber)
                ? (_openBlock(), _createBlock("div", _hoisted_58, " Numéro invalide. Utilisez le format (xxx) xxx-xxxx. "))
                : (_openBlock(), _createBlock("div", _hoisted_59))
            ])
          ]),
          _createVNode("div", _hoisted_60, [
            _hoisted_61,
            _withDirectives(_createVNode("textarea", {
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.addMeInfo = $event)),
              class: ["addme--infobox input", {'error--display':(_ctx.hasInputErrorInfo && !_ctx.validAdditionalInfo)}],
              type: "text",
              placeholder: _ctx.addMeTextPlaceholder,
              tabindex: "5",
              maxlength: 500,
              rows: 5,
              cols: 50,
              onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.showErrorInfo && _ctx.showErrorInfo(...args)))
            }, null, 42, ["placeholder"]), [
              [_vModelText, _ctx.addMeInfo]
            ]),
            (_ctx.hasInputErrorInfo && !_ctx.validAdditionalInfo)
              ? (_openBlock(), _createBlock("div", _hoisted_62, " Limite de 500 caractères "))
              : (_openBlock(), _createBlock("div", _hoisted_63))
          ])
        ]),
        _createVNode("div", _hoisted_64, [
          _createVNode("div", {
            class: ["button button--action", {'button--disabled':!_ctx.validAddRequest}],
            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.requestAddFreeAgent && _ctx.requestAddFreeAgent(...args)))
          }, [
            _hoisted_65
          ], 2)
        ])
      ])
    ])
  ]))
})